// services/pusherclient/pusherClient.ts
import Pusher from 'pusher-js'

let client: Pusher | null = null
let currentToken: string | null = null

const key = process.env.REACT_APP_PUSHER_KEY
const cluster = process.env.REACT_APP_PUSHER_CLUSTER
const apiUrl = process.env.REACT_APP_API_URL

if (!key || !cluster || !apiUrl) {
  // You may want to throw in dev, but don't crash in prod:
  // console.warn('Missing Pusher env vars')
}

export function ensurePusher(token: string | null): Pusher | null {
  if (!key || !cluster || !token) return null

  // Same token → reuse client
  if (client && currentToken === token) {
    return client
  }

  // Token changed / client existed → disconnect and recreate
  if (client) {
    try {
      client.disconnect()
    } catch {}
    client = null
  }

  client = new Pusher(key, {
    cluster,
    forceTLS: true,
    authEndpoint: `${apiUrl}/api/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  })
  currentToken = token
  return client
}

export function getPusherClient(): Pusher | null {
  return client
}

export function disconnectPusher() {
  if (!client) return
  try {
    client.disconnect()
  } catch {}
  client = null
  currentToken = null
}
